var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:[_vm.cssFeatures.hover],style:(_vm.style),attrs:{"data-target-tag":"customerUrlText","title":_vm.params.value || ''}},[_vm._v(_vm._s(_vm.params.value || ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }